import { DataTableProps } from '@warrenbrasil/nebraska-web';
import { RiskCell } from '@/modules/wealth/components/RiskCell';
import { ProductNameCell } from '@/modules/wealth/components/ProductNameCell';

const productLabel = (products: number) => {
  return products > 1 ? `${products} Produtos` : `${products} Produto`;
};

export const columns = (products: number): DataTableProps.Column[] => {
  return [
    {
      label: productLabel(products),
      component: ProductNameCell,
      width: '40%',
      sort: 'type',
      getter: ({ name, type, color }) => ({
        title: name,
        subtitle: type,
        color
      })
    },
    {
      label: 'Percentual',
      width: '20%',
      align: DataTableProps.Align.Right,
      sort: 'percent',
      getter: ({ percent }) => ({
        text: percent.formatted
      })
    },
    {
      label: 'Prazo de resgate',
      width: '20%',
      align: DataTableProps.Align.Right,
      sort: 'withdrawPeriod',
      getter: 'withdrawPeriod'
    },
    {
      label: 'Risco',
      component: RiskCell,
      width: '20%',
      align: DataTableProps.Align.Right,
      sort: 'risk',
      getter: ({ risk }) => ({
        risk
      })
    }
  ];
};
